import { strawberry } from '@/palettes';
import { Assets, Texture, Spritesheet } from 'pixi.js';

const manifest = {
  gear: new URL('../assets/gear.png', import.meta.url).href,
  seed: new URL('../assets/bits/seed.png', import.meta.url).href,
  fly: new URL('../assets/bits/flytest.png', import.meta.url).href,
  fly2: new URL('../assets/bits/flytest2.png', import.meta.url).href,
  test: new URL('../assets/bits/colourtest.png', import.meta.url).href,
  shred1: new URL('../assets/bits/shred1.png', import.meta.url).href,
  shred6: new URL('../assets/bits/shred6.png', import.meta.url).href,
  shred3: new URL('../assets/bits/shred3.png', import.meta.url).href,
  shred4: new URL('../assets/bits/shred4.png', import.meta.url).href,
  squarechunk: new URL('../assets/bits/squarechunk.png', import.meta.url).href,
  wedge: new URL('../assets/bits/orangeslice-squish.png', import.meta.url).href,
  chilli: new URL('../assets/bits/chilliflake.png', import.meta.url).href,
  chilli2: new URL('../assets/bits/chilliflake2.png', import.meta.url).href,
  chilli3: new URL('../assets/bits/chilliflake3.png', import.meta.url).href,
  chilli4: new URL('../assets/bits/chilliflake4.png', import.meta.url).href,
//   smallchunk: new URL('../assets/bits/chunkl.png', import.meta.url).href,
//   smallchunkNormal: new URL('../assets/bits/chunkNormal.png', import.meta.url).href,
  shred: new URL('../assets/bits/shred.png', import.meta.url).href,
  curl: new URL('../assets/bits/curl.png', import.meta.url).href,
  curl1: new URL('../assets/bits/curl1.png', import.meta.url).href,
  pip: new URL('../assets/bits/pip-white.png', import.meta.url).href,
  onion: new URL('../assets/bits/onion.png', import.meta.url).href,
  blackonion:  new URL('../assets/bits/blackonion.png', import.meta.url).href,
  chilliseed:  new URL('../assets/bits/chilliseed.png', import.meta.url).href,
  strawberry1: new URL('../assets/bits/strawberry1-4.png', import.meta.url).href,
  strawberry2: new URL('../assets/bits/strawberry1-3.png', import.meta.url).href,
   strawberry3: new URL('../assets/bits/strawberry4.png', import.meta.url).href,
   strawberry4: new URL('../assets/bits/strawberry-half-dark.png', import.meta.url).href,
   strawberryLightSeeds1: new URL('../assets/bits/WholeStrawberryLightSeeds.png', import.meta.url).href,
   strawberryRare: new URL('../assets/bits/rareStrawberry2.png', import.meta.url).href,
   strawberrychunk1: new URL('../assets/bits/strawberrychunk.png', import.meta.url).href,
   strawberrychunk2: new URL('../assets/bits/strawberrychunk2.png', import.meta.url).href,
   juicepod: new URL('../assets/bits/juicepod.png', import.meta.url).href,
   juicepod2: new URL('../assets/bits/juicepod2.png', import.meta.url).href,
   juicepod3: new URL('../assets/bits/juicepod3.png', import.meta.url).href,
   juicepod4: new URL('../assets/bits/juicepod4.png', import.meta.url).href,
   juicepod5: new URL('../assets/bits/juicepod5.png', import.meta.url).href,
   blueberry1: new URL('../assets/bits/blueberrytiny.png', import.meta.url).href,
   blueberry2: new URL('../assets/bits/blueberry1.png', import.meta.url).href,
   blueberry3: new URL('../assets/bits/blueberry2.png', import.meta.url).href,
   raspberryseg: new URL('../assets/bits/raspberryseg.png', import.meta.url).href,
   raspberryseg2: new URL('../assets/bits/raspseg-seed.png', import.meta.url).href,
   raspberryseg3: new URL('../assets/bits/raspseg-seed2.png', import.meta.url).href,
   raspseed: new URL('../assets/bits/raspseed.png', import.meta.url).href,
   raspchunk3: new URL('../assets/bits/raspChunk3-base.png', import.meta.url).href,
   raspberry:new URL('../assets/bits/raspberry.png', import.meta.url).href,
   blackberry: new URL('../assets/bits/blackberry2.png', import.meta.url).href,
   raspberryContrast: new URL('../assets/bits/blackberry-dark.png', import.meta.url).href,
   orangebase: new URL('../assets/bits/orange-base.png', import.meta.url).href,
   bean1: new URL('../assets/bits/bean1.png', import.meta.url).href,
   bean2: new URL('../assets/bits/bean2.png', import.meta.url).href,
   bean3: new URL('../assets/bits/bean3.png', import.meta.url).href,
   bean4: new URL('../assets/bits/bean4.png', import.meta.url).href,
   arrowLeft: new URL('../assets/icons/arrowLeft.png', import.meta.url).href,
   arrowRight: new URL('../assets/icons/arrowRight.png', import.meta.url).href,
};

const rotationSheets = {
    cube: [new URL('../assets/bits/newcube.png', import.meta.url).href,
                new URL('../assets/bits/newcube.json', import.meta.url).href],
    trianglechunk: [new URL('../assets/bits/trianglechunk.png', import.meta.url).href,
        new URL('../assets/bits/trianglechunk.json', import.meta.url).href],
    littlesegmenttest: [new URL('../assets/bits/raspseg.png', import.meta.url).href,
        new URL('../assets/bits/raspseg.json', import.meta.url).href],
    raspchunk: [new URL('../assets/bits/raspchunk.png', import.meta.url).href,
        new URL('../assets/bits/raspchunk.json', import.meta.url).href],
    raspchunk2: [new URL('../assets/bits/raspchunk2.png', import.meta.url).href,
        new URL('../assets/bits/raspchunk2.json', import.meta.url).href],
    raspchunk4: [new URL('../assets/bits/raspchunk4.png', import.meta.url).href,
        new URL('../assets/bits/raspchunk4.json', import.meta.url).href],
    orangepulp: [new URL('../assets/bits/orange-pulp.png', import.meta.url).href,
        new URL('../assets/bits/orange-pulp.json', import.meta.url).href],
    earth: [new URL('../assets/bits/earth.png', import.meta.url).href,
        new URL('../assets/bits/earth.json', import.meta.url).href],
    clouds: [new URL('../assets/bits/clouds.png', import.meta.url).href,
        new URL('../assets/bits/clouds.json', import.meta.url).href],
        jamjar: [new URL('../assets/bits/jamjarTest2.png', import.meta.url).href,
        new URL('../assets/bits/jamjar.json', import.meta.url).href],
}

// const normalKeys = ['smallchunkNormal'];

// type TextureKey = keyof typeof manifest;

const loadedSheets: Record<string, Spritesheet> = {};

export async function preloadAssets(): Promise<void> {
    // const regularAssets = Object.entries(manifest)
    //     // .filter(([key]) => !normalKeys.includes(key))
    //     .map(([, url]) => url);
    
    // // const normalAssets = Object.entries(manifest)
    // //     // .filter(([key]) => normalKeys.includes(key))
    // //     .map(([, url]) => ({ src: url, data: { alphaMode: 'no-premultiply-alpha' } }));
    
    // await Assets.load([...regularAssets,
    // //  ...normalAssets
    // ]);

    await Assets.load(Object.values(manifest));

    

    for (const [key, [pngUrl, jsonUrl]] of Object.entries(rotationSheets)) {
        
        const texture = await Assets.load(pngUrl)
        const jsonText = await fetch(jsonUrl).then(r => r.text());
        const json = JSON.parse(jsonText);
        // console.log(json)
        // console.log(JSON.stringify(json, null, 2));
        console.log(structuredClone(json));
        const sheet = new Spritesheet(texture, json);
        await sheet.parse();
        loadedSheets[key] = sheet;
    }

}

export function getTexture(key: string): Texture | Spritesheet | undefined {
    if ( key in manifest) {
        if (key in loadedSheets) {
            console.error("ERROR - Asset keys not unique!")
            return;
        }
        return Texture.from(manifest[key as keyof typeof manifest]);
    }
    if (key in loadedSheets) {
        return loadedSheets[key]
    }
    return undefined;
}